
import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import { nativeBridgeConfig } from '@/utils/nativeBridge'

Vue.use(Vuex)

const modulesFiles = require.context('./modules', true, /\.js$/)
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

let fetchBaseInfoPromise = null
// 当前 H5 会话是否已从原生拉取过最新 BaseInfo（每次重新打开 H5 会重置）
let baseInfoReady = false

function commitBaseInfo(commit, parsed) {
  localStorage.setItem('BaseInfo', JSON.stringify(parsed))
  if (parsed.appCode != null) {
    localStorage.setItem('appCode', parsed.appCode)
  }
  if (parsed.customerId != null) {
    localStorage.setItem('userCode', parsed.customerId)
  }
  const bsInfo = {
    appCode: Number(parsed.appCode),
    version: parsed.versionCode,
    userCode: Number(parsed.customerId),
    imei: parsed.imei,
    idfv: parsed.idfv,
    idfa: parsed.idfa,
    ip: parsed.ip,
    longitude: parsed.longitude,
    latitude: parsed.latitude,
    token: parsed.token,
    mColor: parsed.mColor
  }
  if (parsed.customerId && window.mixpanel) {
    window.mixpanel.identify(parsed.customerId)
  }
  commit('SET_FLUTTER_BASE_INFO', bsInfo)
  return bsInfo
}

const store = new Vuex.Store({
  state: {
    flutter_baseInfo: {},
    flutter_cId: '',
    ifscCode: '',
    showSidebar: false,
  },
  getters: {
    ...getters,
    getShowSidebar: state => state.showSidebar,
  },
  mutations: {
    setShowSidebar(state, value) {
      state.showSidebar = value;
    },
    getFromApp(state, n) {
      state.flutter_baseInfo = n
    },
    getCustomerId(state, n) {
      state.flutter_cId = n
    },
    getIfscCode(state, n) {
      state.ifscCode = n
    },
    SET_FLUTTER_BASE_INFO(state, info) {
      state.flutter_baseInfo = info;
    },
  },
  actions: {
    toggleSidebar({ commit }, value) {
      commit('setShowSidebar', value);
    },
    async fetchFlutterBaseInfo({ commit, state }, { force = false } = {}) {
      // 同一会话内已拉取过则直接复用；每次重新打开 H5 会走 force 或 baseInfoReady=false
      if (!force && baseInfoReady && state.flutter_baseInfo.appCode) {
        return state.flutter_baseInfo
      }

      if (fetchBaseInfoPromise) {
        return fetchBaseInfoPromise
      }

      fetchBaseInfoPromise = (async () => {
        const hashParams = new URLSearchParams(window.location.hash.split('?')[1])
        const appCode = hashParams.get('appCode') || localStorage.getItem('appCode')
        console.log(appCode, window.location, 'appCode')

        if (!appCode) {
          throw new Error('appCode is required')
        }
        localStorage.setItem('appCode', appCode)

        try {
          const result = await nativeBridgeConfig.nativeCall(appCode + '-2')
          console.log(result, 'fetchFlutterBaseInfo -2 result')

          if (!result || result === 'no') {
            throw new Error('Failed to get BaseInfo from native')
          }

          const parsed = typeof result === 'string' ? JSON.parse(result) : result
          commitBaseInfo(commit, parsed)
          baseInfoReady = true

          if (!parsed.token) {
            await nativeBridgeConfig.nativeCall(localStorage.getItem('appCode') + '-4')
          }

          return state.flutter_baseInfo
        } catch (error) {
          if (error.message === 'SessionExpired') {
            try {
              await nativeBridgeConfig.nativeCall(localStorage.getItem('appCode') + '-4')
            } catch (logoutError) {
              console.error(`loginOut-error: "${logoutError}"`)
            }
          }
          throw error
        }
      })()

      try {
        return await fetchBaseInfoPromise
      } finally {
        fetchBaseInfoPromise = null
      }
    },
  },
  modules,
});

export default store
